import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";

export class DataSecurityService {
    static $inject = ["$q", "aclService"];
    constructor(private $q: ng.IQService) {

    }


    filterVisibleGroupsCharacteristics(acls: string[], templateMetaData: Models.ICharacteristicMetaDataCollection, charDatas: Models.ICharDatas, showEmptyCMDs: boolean) {
        //var cmdAcls = this.getCMDAcls(templateMetaData);
        return _(templateMetaData.characteristicMetaDatas)
            .filter(cmd => {
                var canRead = Utils.AclUtil.hasAccess(acls, cmd.acl, Consts.AccessRight.Read);
                return canRead && (showEmptyCMDs || !Utils.CharUtil.isCharDataEmpty(charDatas[cmd.tagLabel]));
            })
            .sortByOrder([cmd => cmd.groupID, cmd => cmd.sequenceNumber])
            .value();
    }

}
